export default "__VITE_ASSET__CgNIH032__"